<template>
<div class="result-box">
    <div v-show="isFail" class="error-box">
        <div class="fail_">
        <img src="../../assets/fail.png" alt="fail" />
        <div class="text_ text_1">出错了！投保失败！</div>
        <div class="text_info">
            <div class="text_">错误原因：{{errorTip}}</div>
        </div>
        </div>
    </div>
    <div v-show="isSuccess" class="success_" @click="clickSuceess">
        <img src="../../assets/success.png" alt="success" />
        <div class="text_ text_1">订单提交成功!</div>
        <div class="text_info">
          <div class="text_">订单号：{{ this.policyId }}</div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        policyId: '',
		isSuccess: false, // 投保成功
		isFail: false, // 投保失败
		timer: null,
		errorTip: ''
      };
    },
    computed: {
      checkRiskUpload() {
        let rickObj = JSON.parse(sessionStorage.getItem('checkRiskUpload'));
        console.log(rickObj);
        return rickObj;
      },
    },
	mounted() {
      const { policyId } = this.$route.query;
      this.policyId = policyId;	
	this.startLoop();
      this.$nextTick(() => {
        let policyId = this.policyId.split(',') && this.policyId.split(',')[0];
        if (window.clairvoyanceRecord) {
          window.clairvoyanceRecord.save();
          this.$refs.success.click();
          window.clairvoyanceRecord.finish({
            policyId: policyId
          });
          console.log('%cclairvoyanceRecordFinish == > 结束录制', 'color: green');
        } else {
          setTimeout(function () {
            if (window.clairvoyanceRecord) {
              window.clairvoyanceRecord.finish({
                policyId: policyId
              });
              console.log('%cclairvoyanceRecordFinish == > 结束录制', 'color: green');
            }
          }, 1000);
        }
      })
    },
    methods: {
		clickSuceess() {
			console.log('页面点击了')
		},
		startLoop() {
			//轮询支付结果
			let i = 20;
			let policyId = this.policyId;
			this.timer = setInterval(() => {
				i--;
				if (i < 1) {
					clearInterval(this.timer);
				}
				this.$api
				.queryPolicy({
					policyId
				}) //获取订单信息 是否支付成功
				.then(res => res.data)
				.then(data => {
					// debugger
					const { status, remark } = data.content.salPolicy;
					this.status = status;
					console.log(this.status);
					if (status == '1') {
						//支付成功
						clearInterval(this.timer); //结束轮询
						this.isSuccess = true;
					} else if (status == '-1') {
						this.$message.error(remark);
						this.errorTip = remark;
						this.isFail = true;
					}
				})
				.catch(err => {
					console.log(err)
					this.isFail = true;
					clearInterval(this.timer);
				});
			}, 3000);
		},
    },
    
  };
</script>

<style lang="scss" scoped>
	.result-box {
		background: #fff;
		min-height: 100vh;
		min-width: 100vw;
		z-index: 9999999;
		padding-top: 20px;
		position: fixed;
		top: 0;
		left: 0;
	}
  .error-box,
  .success_  {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	align-items: center;
	img {
		width: 200px;
	}
  }
  .error-box,
  .success_ {
    .text_info {
      margin: 10px 0;
    }

    .text_ {
      font-size: 11px;
      font-family: Microsoft YaHei UI;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }

    .text_1 {
      font-size: 18px;
      font-weight: bold;
      color: rgba(254, 152, 69, 1);
      text-align: center;
    }

    .btn_list {
      display: flex;
      justify-content: center;

      .btn_ {
        margin: 19px;
        border: 1px solid rgba(254, 143, 45, 1);
        width: 150px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: rgba(254, 143, 45, 1);

        .btn_a {
          color: inherit;
          flex: 1;
          text-align: center;
        }
      }

      .btn_:hover {
        color: #fff;
        background: rgba(254, 143, 45, 1);
      }
    }
  }

  .success-test {
    font-size: 16px;
    text-indent: 2em;
  }
</style>